/**
 * Google My Business (GMB) location fields
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.gmb');

goog.require('yext.notify');
goog.require('yext');
goog.require('yext.dam.asset');
goog.require('yext.dam.asset.Asset');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.location.helpers');
goog.require('yext.photoupload.Photo');
goog.require('yext.scheduledupdates.dialog.CancelDialog');
goog.require('yext.scheduledupdates.dialog.RescheduleDialog');
goog.require('yext.scheduledupdates.dialog.RevertDialog');
goog.require('yext.time');

yext.gmb.MINIMUM_SIZE_CONSTRAINTS = {
  width: 250,
  height: 250,
};

yext.gmb.PROFILE_PHOTO_CONSTRAINTS = {
  width: 250,
  height: 250,
  aspectRatio: 1,
  cropOnlyOnInteraction: true,
};

yext.gmb.COVER_PHOTO_CONSTRAINTS = {
  width: 480,
  height: 270,
  aspectRatio: 16/9,
  cropOnlyOnInteraction: true,
};

yext.gmb.PROFILE_PHOTO_KEY = 'location.google_profile_photo';
yext.gmb.COVER_PHOTO_KEY = 'location.google_cover_photo';

yext.gmb.PROFILE_PHOTO_CTX_SELECTOR = '.js-gmb-profile-photo';
yext.gmb.COVER_PHOTO_CTX_SELECTOR = '.js-gmb-cover-photo';

/**
 * @param {!Object?} options  options for the view
 * @param {string?} ctxSelector  optional selector to select the element
 *
 * @return {GooglePhotoView} GooglePhotoView for cover photo
 */
yext.gmb.newGoogleCoverPhotoView = function(options, ctxSelector) {
  options = options || {};
  var $ctx = $(ctxSelector || '.js-gmb-cover-photo-section');
  var view = new yext.gmb.GooglePhotosView($ctx, {
    photoKey: yext.gmb.COVER_PHOTO_KEY,
    photoCtxSelector: yext.gmb.COVER_PHOTO_CTX_SELECTOR,
    photoConstraints: yext.gmb.COVER_PHOTO_CONSTRAINTS,
    emptyMessage: yext.msg('No Cover Photo'),
  }, options);
  return view;
};

/**
 * @param {!Object?} options  options for the view
 * @param {string?} ctxSelector  optional selector to select the element
 *
 * @return {GooglePhotoView} GooglePhotoView for profile photo
 */
yext.gmb.newGoogleProfilePhotoView = function(options, ctxSelector) {
  options = options || {};
  var $ctx = $(ctxSelector || '.js-gmb-profile-photo-section');
  var view = new yext.gmb.GooglePhotosView($ctx, {
    container: $ctx,
    photoKey: yext.gmb.PROFILE_PHOTO_KEY,
    photoCtxSelector: yext.gmb.PROFILE_PHOTO_CTX_SELECTOR,
    photoConstraints: yext.gmb.PROFILE_PHOTO_CONSTRAINTS,
    emptyMessage: yext.msg('No Profile Photo'),
  }, options);
  return view;
};

/**
 * @return boolean True if cover section exists
 */
yext.gmb.hasCoverPhotoSection = function() {
  return !!$('.js-gmb-cover-photo-section').length;
};

/**
 * @return boolean True if profile section exists
 */
yext.gmb.hasProfilePhotoSection = function() {
  return !!$('.js-gmb-profile-photo-section').length;
};

/**
 * Simple model for google photo
 *
 * @constructor
 * @param {!Object} data The photo data
 * @param {key} A unique key for uploading new images
 */
yext.gmb.GooglePhoto = function(data, key) {
  this.key = key;
  this.setData(data);
};

/**
 * @param {Asset} asset Data used when an image is
 * selected which can contain asset details, files, or cropped image data
 */
yext.gmb.GooglePhoto.prototype.setUploadData = function(asset) {
  if (!(asset instanceof yext.dam.asset.Asset)) {
    throw new TypeError('Please use an asset');
  }
  this.photoData = new yext.photoupload.Photo({
    asset: asset,
  });
  this.file = asset.file;
  this.fileInput = asset.fileInput;
};

/**
 * Set model properties from a simple object
 *
 * @param {!Object} data The photo data
 */
yext.gmb.GooglePhoto.prototype.setData = function(data) {
  this.url = data.url || '';
  this.indeterminate = data.indeterminate === true;
  this.timestamp = data.timestamp;
  this.clearUploadData();
};

/**
 * Clear all upload data
 */
yext.gmb.GooglePhoto.prototype.clearUploadData = function() {
  this.photoData = undefined;
  this.file = undefined;
  this.fileInput = undefined;
};

/**
 * @return {boolean} True if there is a file to be uploaded
 */
yext.gmb.GooglePhoto.prototype.hasFile = function() {
  return this.file != undefined;
};

/**
 * @return {boolean} True if there is cropped image available
 */
yext.gmb.GooglePhoto.prototype.hasCroppedPhoto = function() {
  return this.getPhotoData().croppedImage != undefined;
};

/**
 * Gets a url that can be rendered. For pages that do not upload immediately
 * this will be the base64 encoded cropped image data
 *
 * @return {string} The photo url
 */
yext.gmb.GooglePhoto.prototype.getUrlForRender = function() {
  if (this.photoData) {
    return this.photoData.getUrl();
  }
  return this.url;
};

/**
 * Checks whether the field has photo or not
 *
 * @return {boolean} True if there is a photo in the field
 */
yext.gmb.GooglePhoto.prototype.hasValue = function() {
  return !!this.photoData || !!this.url;
};

/**
 * @return {Photo} Photo object used for saving
 */
yext.gmb.GooglePhoto.prototype.getPhotoData = function() {
  if (this.photoData) {
    return this.photoData;
  } else {
    return new yext.photoupload.Photo({
      url: this.url,
    });
  }
};

/**
 * Get a name/value pair array for the model's data
 */
yext.gmb.GooglePhoto.prototype.getData = function() {
  return [{
    name: this.key + '.data',
    value: yext.JSON.stringify(this.getPhotoData()),
  }, {
    name: this.key + '.timestamp',
    value: this.timestamp,
  }, {
    name: 'field',
    value: this.key,
  }];
};

/**
 * GMB profile and cover photos view model
 *
 * @constructor
 * @param {!Object}  context jQuery element of the view
 * @param {object?} photoOptions Options for the photo field
 * @param {object?} options Optional configuration
 */
yext.gmb.GooglePhotosView = function(context, photoOptions, options) {
  this.$ctx = context;
  this.$row = this.$ctx.closest('tr');
  this.$scheduledUpdateActions = this.$row.find('.js-scheduled-update-actions');

  this.options = options || {};
  this.$entityAddForm = options.$entityAddForm;
  this.photoOptions = photoOptions || {};

  this.options.isSuggestEditMode = this.$row.data('suggestEditMode');
  this.options.isFutureEditMode = this.$row.data('futureEditMode');

  this.profileDate = yext.getUrlParams().date;

  this.parsePhotos();
  this.assetSelectorConfigurations();
  this.bindEditButtons();
  this.bindScheduledUpdateActions();
};

yext.gmb.GooglePhotosView.prototype.parsePhotos = function() {
  this.photo = this.parsePhoto(this.$ctx);
};

/**
 * Parses the photo info from the DOM
 *
 * @param {!Object} the jquery context of the DOM
 */
yext.gmb.GooglePhotosView.prototype.parsePhoto = function($ctx) {
  var data = {};
  var $photoCtx = $ctx.find(this.photoOptions.photoCtxSelector);
  data.timestamp = $photoCtx.data('timestamp');
  if ($photoCtx.data('indeterminate') == true) {
    data.indeterminate = true;
  } else {
    var $img = $photoCtx.find('img');
    if ($img.length) {
      data.url = $img.attr('src');
    }
  }
  return new yext.gmb.GooglePhoto(data, this.photoOptions.photoKey);
};

/**
 * Sets up configurations for the asset selector for both photo types
 */
yext.gmb.GooglePhotosView.prototype.assetSelectorConfigurations = function() {
  this.showSelectorForPhoto = this.configuration({
    constraints: this.photoOptions.photoConstraints,
    fieldName: this.photoOptions.photoKey,
  });
};

/**
 * Bind the edit photo buttons click and hover events
 */
yext.gmb.GooglePhotosView.prototype.bindEditButtons = function() {
  var self = this;

  this.$ctx.find(this.photoOptions.photoCtxSelector)
    .on('mouseenter mouseleave', function(e) {
      var entered = e.type == 'mouseenter';
      $(this).find('.js-edit-photo').toggle(entered);
      $(this).find('.js-remove-photo').toggle(entered && self.photo.url != null && self.photo.url !== '');
    });

  this.$ctx.find(this.photoOptions.photoCtxSelector + ' .js-remove-photo').click(function() {
    self.photo.url = '';
    self.optionalUploadAndBroadcast(self.photo);
  });

  this.$ctx.find(this.photoOptions.photoCtxSelector + ' .js-edit-photo').click(function() {
    self.showSelectorForPhoto();

    const addPhotoCallback = self.$entityAddForm
      ? function(asset) {
        self.photo.setUploadData(asset);
        self.render(self.photo);
        self.setEntityAddPageData(asset);
      }
      : function(asset) {
        self.photo.setUploadData(asset);
        self.optionalUploadAndBroadcast(self.photo);
      };

    self.bindOnAddPhoto(addPhotoCallback);
  });
};

/**
 * Submission function used for GMB photos on the entity add page. Rather than
 * submitting the form, this path simply stores hidden inputs with the appropriate
 * data to be submitted with the rest of the fields all at once.
 */
yext.gmb.GooglePhotosView.prototype.setEntityAddPageData = function(asset) {
  const data = yext.JSON.stringify(this.photo.getPhotoData());

  this.$entityAddForm.find('input[name="field"][value="' + this.photoOptions.photoKey + '"]').remove();
  this.$entityAddForm.find('input[name=\'' + this.photoOptions.photoKey + '.data\']').remove();
  this.$entityAddForm.find('input[name="' + this.photoOptions.photoKey + '.timestamp"]').remove();
  this.$entityAddForm.append('<input type="hidden" name="field" value="' + this.photoOptions.photoKey + '">');
  this.$entityAddForm.append('<input type=\'hidden\' name=\'' + this.photoOptions.photoKey + '.data\' value=\'' + data + '\'>');
  this.$entityAddForm.append('<input type="hidden" name="' + this.photoOptions.photoKey + '.timestamp" value="0">');
};

/**
 * Binds the scheduled update actions to its elements
 */
yext.gmb.GooglePhotosView.prototype.bindScheduledUpdateActions = function() {
  var self = this;
  this.$scheduledUpdateActions.find('.js-cancel-scheduled-update').on('click', function() {
    var cancelDialog = new yext.scheduledupdates.dialog.CancelDialog(self.profileDate, self.photoOptions.photoKey);
    cancelDialog.show();
  });

  this.$scheduledUpdateActions.find('.js-reschedule-scheduled-update').on('click', function() {
    var rescheduleDialog = new yext.scheduledupdates.dialog.RescheduleDialog(self.profileDate, self.photoOptions.photoKey);
    rescheduleDialog.show();
  });
};

/**
 * Render one of the models
 *
 * @param {GooglePhoto} model The model for the cover or profile photo
 */
yext.gmb.GooglePhotosView.prototype.render = function(model) {
  var $content;
  var text;
  if (model.indeterminate) {
    text = yext.msg('Various Content');
  } else {
    var url = model.getUrlForRender();
    if (url) {
      $content = $('<img />').attr('src', url);
    } else {
      text = this.photoOptions.emptyMessage;
    }
  }
  if (text) {
    $content = $('<span />').text(text);
  }

  this.$ctx.find(this.photoOptions.photoCtxSelector + ' .js-photo-content').empty().append($content);
};

/**
 * @param {function()} cb Callback for when the photo is added
 */
yext.gmb.GooglePhotosView.prototype.bindOnAddPhoto = function(cb) {
  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    cb(asset);
  });
};

/**
 * @param {GooglePhoto} model The model that has been updated
 */
yext.gmb.GooglePhotosView.prototype.optionalUploadAndBroadcast = function(model) {
  var self = this;

  if (yext.isString(this.options.uploadUrl)) {
    this.upload(model, false);
  } else {
    self.render(model);
    self.message('updated');
  }
};

/**
 * Function called when upload is successful
 *
 * @param {GooglePhoto} model The model that has been updated
 * @param response the response object returned
 */
yext.gmb.GooglePhotosView.prototype.onUploadSuccess = function(model, response) {
  // NOTE(mattjs) This reconciles Locations format with Entities format
  if (response.field) {
    response.url = response.field.url;
    response.timestamp = response.field.timestamp;
  }
  var self = this;
  if (response.error) {
    this.parseErrorResponse(response);
  } else if (response.isSuggestedEdit
    || (response.metadata && response.metadata.suggestedEditIds)
    || response.suggestedEditIds) {
    window.location.reload();
  } else if (response.url !== null) {
    model.setData(response);
    self.render(model);
    self.message('updated');
    // Stale comes after updated so a previous error can be cleared
    if (response.stale) {
      self.error(yext.location.helpers.staleErrorMessage);
    }
  }

  this.toggleScheduledUpdateLabelAndActions(true);

  if (this.options.isFutureEditMode) {
    var metadata = response.metadata;
    if (response.minRevertDate) {
      // Show revert dialog for location profile
      yext.scheduledupdates.dialog.RevertDialog(
        response.fieldIds,
        response.customFieldIds,
        response.minRevertDate);
    } else if (metadata && metadata.minRevertDate) {
      // Show for entities, which store the same info, but under metadata
      yext.scheduledupdates.dialog.RevertDialog(
        null, // field ids
        null, // custom field ids
        metadata.minRevertDate,
        metadata.entityFieldIds);
    }
  }
};

/**
 * Get the error string from the response object and call error() function to
 * trigger 'error' event
 *
 * @param response the response object returned
 */
yext.gmb.GooglePhotosView.prototype.parseErrorResponse = function(response) {
  if (yext.isObject(response.error)) {
    if (yext.gmb.COVER_PHOTO_KEY in response.error) {
      this.error(response.error[yext.gmb.COVER_PHOTO_KEY]);
    } else if (yext.gmb.PROFILE_PHOTO_KEY in response.error) {
      this.error(response.error[yext.gmb.PROFILE_PHOTO_KEY]);
    } else {
      this.onUploadError();
    }
  } else if (yext.isString(response.error)) {
    this.error(response.error);
  } else {
    this.onUploadError();
  }
};

/**
 * Show or hide the scheduled update labels and action elements
 *
 * @param {show} boolean
 */
yext.gmb.GooglePhotosView.prototype.toggleScheduledUpdateLabelAndActions = function(show) {
  if (this.options.isFutureEditMode) {
    this.$row.find('.js-scheduled-update-label').toggle(show);
    this.$scheduledUpdateActions.toggle(show);
    this.$row.toggleClass('scheduled-updates-highlight', show);
  }
};

/**
 * Function called when upload errors
 */
yext.gmb.GooglePhotosView.prototype.onUploadError = function() {
  this.error(yext.msg('There was an error while saving the google photo'));
};

/**
 * This method abstracts away upload with and without files
 *
 * @param {GooglePhoto} model The model for the field being saved
 */
yext.gmb.GooglePhotosView.prototype.upload = function(model) {
  var self = this;
  var timeout = yext.dialog.showDelayedProgressDialog(yext.msg('Saving ...'));
  var data = model.getData();

  if (model.hasFile() && !model.hasCroppedPhoto()) {
    model.photoData.setFileIndex(0);
    yext.fileupload.upload({
      files: [model.file],
      fileInputs: [model.fileInput],
      action: self.options.uploadUrl,
      data: data,
      done: function(response) {
        self.onUploadSuccess(model, response);
      },
      error: function() {
        self.onUploadError();
      }, always: function() {
        yext.dialog.hideDelayedProgressDialog(timeout);
      },
    });
  } else {
    $.ajax({
      type: 'POST',
      url: self.options.uploadUrl,
      data: data,
      success: function(response) {
        self.onUploadSuccess(model, response);
      },
      error: function() {
        self.onUploadError();
      },
    }).always(function() {
      yext.dialog.hideDelayedProgressDialog(timeout);
    });
  }
};

/**
 * @param {string} message The message name
 * @param {!Object} data Optional data attached to the message
 */
yext.gmb.GooglePhotosView.prototype.message = function(message, data) {
  $(this).trigger(message, data);
};

/**
 * @param {!Object} errorMessage Error text
 */
yext.gmb.GooglePhotosView.prototype.error = function(errorMessage) {
  if (this.options.showToastMessageOnError) {
    yext.notify.showError(errorMessage);
  }
  $(this).trigger('error', errorMessage);
};

/**
 * Returns a function that will show the asset selector with a set
 * of configurations
 *
 * @return {function()} Shows the asset selector with a given set of configurations
 */
yext.gmb.GooglePhotosView.prototype.configuration = function(options) {
  var $ctx = this.$ctx.find(this.photoOptions.photoCtxSelector);
  var selectorUsage = goog.module.get('yext.dam.assetselector.usage');

  options.constraints.aspectRatioId = $ctx.data('aspectRatioId');
  return function() {
    yext.dam.assetselector.show({
      'type': 'PHOTO',
      'includeUsedAssets': false,
      'isSuggestedEditMode': this.options.isSuggestEditMode,
      'isFutureEditMode': this.options.isFutureEditMode,
      'usageType': selectorUsage.forProfileFields(options.fieldName),
    },
    options.fieldName,
    undefined, // custom field id
    options.constraints);
  };
};
